export enum TEST_TAKER_TYPE {
  FROM_EMAIL,
  TICKET,
  ANONYMOUS
}